import { NgZone } from '@angular/core';
import { Observable, OperatorFunction } from 'rxjs';

const DEBUG = false;

export const runInAngular = <T,R>(zone: NgZone): OperatorFunction<any,any> => {
  return (source) => {
    return new Observable((observer) => {
      source.subscribe({
        next: (value) => zone.run(() => {
          if (DEBUG) {console.log('runInAngular.next() called on %o', value);}
          observer.next(value);
        }),
        error: (err) => observer.error(err),
        complete: () => observer.complete()
      });
    });
  };
};
